import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EMPTY, Subscription, take, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BirthdayService } from '../../share/service/birthday.service';

@Component({
  selector: 'app-birthday-check',
  templateUrl: './birthday-check.component.html',
  styleUrls: ['./birthday-check.component.scss'],
})
export class BirthdayCheckComponent implements OnInit {
  private subGet!: Subscription;

  public inputFocus: boolean = false;
  public correctDate: boolean = false;
  public correctUserBdate: boolean = false;
  public bdayCheckMessage!: string;
  public bdayCheckTime!: string;
  private birthDay!: string;
  private birthMonth!: string;
  private birthYear!: string;
  private token!: string;
  private subGetSend: boolean = false;
  private isHandlingBack = false;

  public form = this.fb.group({
    birthday: ['', Validators.required],
  });

  get birthday() {
    return this.form.get('birthday')?.value;
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (
      !this.eRef.nativeElement
        .querySelector('.form__input')
        .contains(event?.target)
    ) {
      this.inputFocus = this.birthday !== '';
    }
  }

  constructor(
    private fb: FormBuilder,
    private eRef: ElementRef,
    private birthdayService: BirthdayService,
  ) {}

  preventBack() {
    window.history.forward();
  }

  // re-entrancy guard — popstate→navigate can recurse (stack overflow)
  private onPopState = (): void => {
    if (this.isHandlingBack) {
      return;
    }
    this.isHandlingBack = true;
    window.location.replace('/');
  };

  ngOnInit(): void {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.token = urlParams.get('t') ?? '';

    setTimeout(() => {
      history.pushState('/', '', window.location.href);
      history.replaceState('/', '', window.location.href);
    }, 100);

    window.addEventListener('popstate', this.onPopState);

    setTimeout(() => this.preventBack(), 100);
  }

  ngOnDestroy() {
    window.removeEventListener('popstate', this.onPopState);
    if (this.subGetSend) {
      this.subGet.unsubscribe();
    }
  }

  labelMove(): void {
    this.inputFocus = true;
  }

  private setUserBdateLocked(locked: boolean): void {
    this.correctUserBdate = locked;
    const control = this.form.get('birthday');
    if (locked) {
      control?.disable({ emitEvent: false });
    } else {
      control?.enable({ emitEvent: false });
    }
  }

  onKeyup(value: string): void {
    let cleanValue = value.toString().replace(/\D/g, '');
    this.transformValue(cleanValue);
  }

  transformValue(value: string) {
    let valueNew: string = '';
    switch (value.length) {
      case 1:
        valueNew = value[0];
        break;
      case 2:
        valueNew = value[0] + value[1];
        break;
      case 3:
        valueNew = value[0] + value[1] + '.' + value[2];
        break;
      case 4:
        valueNew = value[0] + value[1] + '.' + value[2] + value[3];
        break;
      case 5:
        valueNew =
          value[0] + value[1] + '.' + value[2] + value[3] + '.' + value[4];
        break;
      case 6:
        valueNew =
          value[0] +
          value[1] +
          '.' +
          value[2] +
          value[3] +
          '.' +
          value[4] +
          value[5];
        break;
      case 7:
        valueNew =
          value[0] +
          value[1] +
          '.' +
          value[2] +
          value[3] +
          '.' +
          value[4] +
          value[5] +
          value[6];
        break;
      case 8:
        valueNew =
          value[0] +
          value[1] +
          '.' +
          value[2] +
          value[3] +
          '.' +
          value[4] +
          value[5] +
          value[6] +
          value[7];
        break;
    }

    this.birthDay = value.length > 2 ? value[0] + value[1] : '';
    this.birthMonth = value.length > 4 ? value[2] + value[3] : '';
    this.birthYear =
      value.length > 7 ? value[4] + value[5] + value[6] + value[7] : '';

    this.form.patchValue({
      birthday: valueNew,
    });

    if (valueNew.length > 9) {
      this.birthdayValidation(valueNew);
    } else {
      this.correctDate = false;
      this.setUserBdateLocked(false);
    }
  }

  sendBday(value: string): void {
    value = value.replace(/\D\./g, '');
    this.birthdayValidation(value);
    if (this.correctDate) {
      return;
    }
    if (this.birthYear == undefined) {
      this.onKeyup(value);
    }
    const bdayArray = value.split('.');
    let birthday = bdayArray[2] + '-' + bdayArray[1] + '-' + bdayArray[0];

    this.subGetSend = true;
    this.subGet = this.birthdayService
      .validateBday(this.token, birthday)
      .pipe(
        take(1),
        catchError((error) => {
          if (error.status === 403) {
            this.setUserBdateLocked(true);
            const response = JSON.parse(error.error.toString());
            this.timer(response.seconds, response.message);
            return EMPTY;
          }
          return throwError(() => error);
        }),
      )
      .subscribe((data) => {
        this.setUserBdateLocked(false);
        const response = JSON.parse(data.toString());
        window.location.href =
          '/start/kredit-resultpage/?t=' + encodeURIComponent(response.message);
      });
  }

  birthdayValidation(date: string) {
    const regEx =
      /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/g;
    const res = regEx.test(date);
    this.correctDate = !res;
  }

  timer(time: number, message: string) {
    this.parseTime(time, message);
    let interval = setInterval(() => {
      this.parseTime(time, message);

      time = time - 1;
      if (time < 0) {
        clearInterval(interval);
        this.setUserBdateLocked(false);
      }
    }, 1000);
  }

  parseTime(time: number, message: string) {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    this.bdayCheckTime = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    this.bdayCheckMessage = message.replace('{}', this.bdayCheckTime);
  }
}
